import Joi from "joi";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
//import Select from 'react-select';
//import Select from "../../common/select";
import Tooltip from "rc-tooltip";
import React from "react";
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
// import { withRouter } from "react-router-dom";
import withRouter from "../../common/withRouter.jsx";
import Form from "../../common/form.jsx";
import {
  Panel,
  PanelBody,
  PanelHeader,
} from "../../components/panel/panel.jsx";
// import { apiUrl } from "../../config/config.json";
// import http from "../../services/httpService";
import auth from "./../../services/authservice";
import { getCOOItem, saveCOOItem } from "./../../services/cooitems";
import { getrvss } from "./../../services/rvss";
import { saveAttachments } from "../../services/attachments.js";
import countries from "../../common/countries.js";
// import CameraForm from "./CameraForm.js";
import ImageAnnotator from "../../common/ImageAnnotator/ImageAnnotator";
import LockValueCheckbox from "./LockValueCheckbox.js";

const apiUrl = process.env.REACT_APP_API_URL;

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Handle = Slider.Handle;

class COOItem extends Form {
  async componentDidMount() {
    document.title = "Adding COOItem";    
  }
  constructor(props) {
    super(props);

    var maxYesterday = "";
    var minYesterday = DateTime.moment().subtract(1, "day");

    this.minDateRange = (current) => {
      return current.isAfter(minYesterday);
    };
    this.maxDateRange = (current) => {
      return current.isAfter(maxYesterday);
    };
    this.minDateChange = (value) => {
      this.setState({
        maxDateDisabled: false,
      });
      maxYesterday = value;
    };

    this.state = {
      maxDateDisabled: true,
      madeIn: [],
      profiles: [],
      attachments: [],
      RVSs: [],      
      loading: false,
      showCamera: false,
      images: [],
      selectedImage: null,
      annotations: [],
      annotation: {},

      lockRepairVendor: false,
      lockCOOfromPackingList: false,
      lockCOOfromDB: false,
      lockCOOonBox: false,
      lockMadeIn: false,
      lockSKU: false,
      lockBatch: false,
      lockNote: false,
      lockStatus: false,

      inputNewEntry: false,
      data: {
        // user: "",
        repairVendor: "",
        // name: "",
        COOfromPackingList: "",
        COOfromDB: "",
        COOonBox: "",
        madeIn: "",
        SKU: "",
        serial: "",
        batch: "",
        note: "",
        status: "",
      },
      imageSrc: null,
      selectedFile: null,
      errors: {},
    };

    this.RepairVendorOptions = [
      { value: "Nokia (IN)", label: "Nokia (IN)" },
      { value: "Nokia (US)", label: "Nokia (US)" },
      { value: "Nokia (CN)", label: "Nokia (CN)" },
      { value: "Sanmina-SCI (TH)", label: "Sanmina-SCI (TH)" },
      { value: "Sanmina-SCI (HU)", label: "Sanmina-SCI (HU)" },
      { value: "Sanmina-SCI (MX)", label: "Sanmina-SCI (MX)" },
      { value: "Flextronics (HU)", label: "Flextronics (HU)" },
      { value: "Flextronics (IT)", label: "Flextronics (IT)" },
      { value: "Flextronics (RO)", label: "Flextronics (RO)" },
      { value: "Cordon (FR)", label: "Cordon (FR)" },
      { value: "Einea (FR)", label: "Einea (FR)" },
      { value: "DHL Beringe (NL)", label: "DHL Beringe (NL)" },
      { value: "CTDI (DE)", label: "CTDI (DE)" },
      { value: "ALU-EMEA ()", label: "ALU-EMEA ()" },
      { value: "Jabil (MY)", label: "Jabil (MY)" },
      { value: "Siae Microelletronics (IT)", label: "Siae Microelletronics (IT)" },
      { value: "Delta (SG)", label: "Delta (SG)" }, 
      { value: "Delta (HK)", label: "Delta (HK)" },       
      { value: "Unknown ()", label: "Unknown ()" },
    ];

    this.statusOptions = [
      { value: "repaired", label: "Repaired" },
      { value: "new", label: "New" },
      { value: "scrap", label: "Scrap" },
      { value: "unknown", label: "Unknown" },
    ];

    this.labelValueOptions = [
      { value: "SKU", label: "SKU" },
      { value: "serial", label: 'serial' },
      { value: "madeIn", label: 'madeIn' },
      { value: "name", label: 'name' },
      { value: "description", label: 'description' },
    ];

    this.handleSlider = (props) => {
      const { value, dragging, index, ...restProps } = props;
      return (
        <Tooltip
          prefixCls="rc-slider-tooltip"
          overlay={value}
          visible={dragging}
          placement="top"
          key={index}
        >
          <Handle value={value} {...restProps} />
        </Tooltip>
      );
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onChangeImgHandler = this.onChangeImgHandler.bind(this);
    this.handleBoolean = this.handleBoolean.bind(this);
  }

  async populateRVSs() {
    try {
      const { data: allrvss } = await getrvss(); 
      const repairVendorOptions = allrvss?.map((rvs) => ({
        value: rvs.RVS,
        label: rvs.RVS
      }));

      this.setState({ repairVendorOptions });
    } catch (error) {
      console.error("Error fetching rvss:", error);
    }
  }

  async populaterepairVendor() {
    this.repairVendoroptions = this.RepairVendorOptions?.map((option) => (
      <option key={option.repairVendor} value={option.value}>
        {option.value}
      </option>
    ));
  }

  handleBoolean = ({ currentTarget: input }) => {

    this.setState((prevState) => ({
      ...prevState,
      [input.name]: input.value === "yes" ? true : false,
    }));
  };

  async populateCOOItem() {
    try {
      const COOItemId = this.props.params.id;
      console.log("coo id", COOItemId);
      if (COOItemId === "new") return;

      const { data: item } = await getCOOItem(COOItemId);
      console.log("cooItem====---", item)
      this.setState({ attachments: item.attachments });
      this.setState({
        data: this.mapToViewModel(item),
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/error");
    }
  }

  setCurrentUser() {
    const Id = this.props.params.id;

    if (Id !== "new") return;

    const { _id: currentUser_id } = auth.getProfile();
    const data = { ...this.state.data };
    data.user = currentUser_id;
    this.setState({ data: data });
  }

  async componentDidMount() {
    this.setCurrentUser();
    await this.populateRVSs();
    await this.populateCOOItem();
  }

  schema = Joi.object({
    repairVendor: Joi.string().optional().allow(''),
    // annotateImage: Joi.any().optional(),
    SKU: Joi.string().optional(),
    serial: Joi.string().optional(),
  });

  onChangeImgHandler = (event) => {
    this.setState({ imageSrc: event.target.files });
    console.log(event.target.files[0]);
  };

  handledateChange = (e) => {
    const errors = { ...this.state.errors };
    const obj = { date: e };

    const data = { ...this.state.data };
    data["expiredOn"] = e;
    //const data = {...this.state.data};
    //data.date = e;
    this.setState({ data });
    // console.log(this.state.data);
  };

  resetState = () => {
    this.setState((prevState) => ({
      ...prevState, data: {
        ...prevState.data,
        repairVendor: prevState.lockRepairVendor ? prevState.data.repairVendor : "",
        COOfromPackingList: prevState.lockCOOfromPackingList ? prevState.data.COOfromPackingList : "",
        COOonBox: prevState.lockCOOonBox ? prevState.data.COOonBox : "",
        COOfromDB: prevState.lockCOOfromDB ? prevState.data.COOfromDB : "",
        madeIn: prevState.lockMadeIn ? prevState.data.madeIn : "",
        SKU: prevState.lockSKU ? prevState.data.SKU : "",
        serial: "",
        batch: prevState.lockBatch ? prevState.data.batch : "",
        note: prevState.lockNote ? prevState.data.note : "",
        status: prevState.lockStatus ? prevState.data.status : "",
      },
    //  imageSrc: prevState.lockAttachments ? prevState.imageSrc : null,
    }));
  };

  doSubmit = async (COOitem) => {
    this.setState({ loading: true });
    try {
      const { data } = await saveCOOItem(this.state.data);

      if (this.state.imageSrc) {
        await saveAttachments(this.state.imageSrc, "cooitem", data._id, () => { });
      }

      this.setState({ loading: false });

      if (!this.state.inputNewEntry) {
        this.props.navigate("/ERP/COOItems");
      }

      this.resetState();
    } catch (ex) {
      console.log("error", ex);
      if (ex.response) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
        this.setState({ loading: false });
      }
      this.setState({ loading: false });
    }
  };

  mapToViewModel(data) {
    return {
      _id: data._id,
      user: data.user,
      // name: data.name,
      COOfromPackingList: data.COOfromPackingList,
      COOonBox: data.COOonBox,
      COOfromDB: data.COOfromDB,
      madeIn: data.madeIn,
      repairVendor: data.repairVendor,
      SKU: data.SKU,
      status: data.status,
      serial: data.serial,
      // createdOn: data.createdOn,
      note: data.note,
      batch: data.batch,
    };
  }
  handleCapture = (imageSrc) => {
    this.setState((prevState) => ({
      images: [...prevState.images, imageSrc],
    }));
  };

  handleImageSelect = (image) => {
    this.setState({ selectedImage: image });
  };

  handleDeleteImage = (imageIndex) => {
    const { images, annotations, selectedImage } = this.state;

    const updatedImages = images.filter((_img, index) => index !== imageIndex);
    const updatedAnnotations = annotations.filter((_ann, index) => index !== imageIndex);

    this.setState({
      images: updatedImages,
      annotations: updatedAnnotations,
      selectedImage:
        selectedImage === imageIndex
          ? updatedImages.length > 0
            ? 0
            : null
          : selectedImage > imageIndex
            ? selectedImage - 1
            : selectedImage,
    });
  };

  handleAnnotationChange = (annotation) => {
    this.setState({ annotation });
  };

  handleAnnotationSubmit = () => {
    const { selectedImage, annotations, annotation } = this.state;

    if (selectedImage !== null) {
      const updatedAnnotations = [...annotations];
      updatedAnnotations[selectedImage] = [
        ...(updatedAnnotations[selectedImage] || []),
        annotation,
      ];

      this.setState({
        annotations: updatedAnnotations,
        annotation: {},
      });
    }
  };

  handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    const imageUrls = files.map((file) => URL.createObjectURL(file)); // Create URLs for the uploaded files
    this.setState((prevState) => ({
      images: [...prevState.images, ...imageUrls],
    }));
  };

  render() {
    const { data, errors, attachments, images, annotation, annotations, selectedImage, showCamera } = this.state;
    return (
      <React.Fragment>
        <div>
          <h1 className="page-header">Add COOItem</h1>

          <div className="row">
            <div className="col-xl-10">
              <Panel>
                <PanelHeader>Add Item</PanelHeader>
                <PanelBody className="panel-form">
                  <form
                    className="form-horizontal form-bordered"
                    onSubmit={this.handleSubmit}
                  >

                    {/*<label htmlFor="repairVendor">Repair Vendor</label>
  <select
    name="repairVendor"
    id="repairVendor"
    value={this.state.data.repairVendor}
    onChange={this.handleChange}
    className="form-select"
  >
    <option value="">Select a repair vendor</option>
    {this.selectrvss.map((option: any) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>
                      {!data._id && <LockValueCheckbox fieldName="lockRepairVendor" value={this.state.lockRepairVendor} onChange={this.handleBoolean} />}      
</div>            */}
                    {/*     
                      <div className="col-12 col-sm-4">
                        <label>
                          <b>Select Name of Repair Vendor *</b>
                        </label>
                      </div>
                      <div className="col-12 col-sm-6">
                        <CustomSelect
                          clients={this.state?.rvss || []}
                          onSelectChange={this.handleEventChange}
                          height={20}
                          width={20}
                          clientId={this.state.data.rvsNo}
                        />
                      </div>
                    </div>                      */}


                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="repairVendor">
                        Repair Vendor
                      </label>
                      <div className="col-lg-4">
                        <select
                          name="repairVendor"
                          id="repairVendor"
                          value={this.state.data.repairVendor || ""}
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Repair Vendor</option>
                          {this.state.repairVendorOptions?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        {errors.repairVendor && (
                          <div className="alert alert-danger">
                            {errors.repairVendor}
                          </div>
                        )}
                      </div>
                      {!data._id && (
                        <LockValueCheckbox
                          fieldName="lockRepairVendor"
                          value={this.state.lockRepairVendor}
                          onChange={this.handleBoolean}
                        />
                      )}
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="annotateImage">Screen capture of Label</label>

                      <div className="col-lg-4">
                        <button
                          className="btn btn-primary inline-block me-2"
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({ showCamera: !this.state.showCamera });
                          }}
                        >
                          {this.state.showCamera ? 'Hide Camera' : 'Take photo'}
                        </button>

                        <input
                          type="file"
                          accept="image/*"
                          multiple
                          onChange={this.handleFileUpload}
                        />
                      </div>
                      {/* {!data._id && <LockValueCheckbox fieldName="lockAnnotateImage" value={this.state.lockAnnotateImage} onChange={this.handleBoolean} />} */}
                    </div>

                    <ImageAnnotator
                      showCamera={showCamera}
                      images={images} annotation={annotation}
                      annotations={annotations} selectedImage={selectedImage} handleAnnotationChange={this.handleAnnotationChange} handleAnnotationSubmit={this.handleAnnotationSubmit} handleCapture={this.handleCapture} handleDeleteImage={this.handleDeleteImage} handleImageSelect={this.handleImageSelect}
                      options={this.labelValueOptions}
                    />

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="SKU">SKU</label>

                      <div className="col-lg-4">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter SKU/Item code/ Material-code"
                          name="SKU"
                          value={
                            this.state.data.SKU &&
                            this.state.data.SKU
                          }
                          onChange={this.handleChange}
                        />
                      </div>
                      {!data._id && <LockValueCheckbox fieldName="lockSKU" value={this.state.lockSKU} onChange={this.handleBoolean} />}
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-4 col-form-label" htmlFor="serial">Serial</label>

                      <div className="col-lg-4">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Enter serial of item/equipment"
                          name="serial"
                          value={
                            this.state.data.serial &&
                            this.state.data.serial
                          }
                          onChange={this.handleChange}
                        />
                      </div>
                      {/* {!data._id && <LockValueCheckbox fieldName="lockSerial" value={this.state.lockSerial} onChange={this.handleBoolean} />} */}
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-4 col-form-label"
                        htmlFor="madeIn"
                      >COO from Item
                      </label>

                      <div className="col-lg-4">
                        <select
                          name="madeIn"
                          id="madeIn"
                          value={
                            this.state.data.madeIn && this.state.data.madeIn
                          }
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Country</option>
                          {countries?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        {errors.madeIn && (
                          <div className="alert alert-danger">
                            {errors.madeIn}
                          </div>
                        )}
                      </div>
                      {!data._id && <LockValueCheckbox fieldName="lockMadeIn" value={this.state.lockMadeIn} onChange={this.handleBoolean} />}
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-4 col-form-label"
                        htmlFor="COOfromDB"
                      >COO on Printed Label
                      </label>

                      <div className="col-lg-4">
                        <select
                          name="COOfromDB"
                          id="COOfromDB"
                          value={
                            this.state.data.COOfromDB && this.state.data.COOfromDB
                          }
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Country on Printed Label</option>
                          {countries?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        {errors.COOfromDB && (
                          <div className="alert alert-danger">
                            {errors.COOfromDB}
                          </div>
                        )}
                      </div>
                      {!data._id && <LockValueCheckbox fieldName="lockCOOfromDB" value={this.state.lockCOOfromDB} onChange={this.handleBoolean} />}
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-4 col-form-label"
                        htmlFor="COOonBox"
                      >COO on Box
                      </label>

                      <div className="col-lg-4">
                        <select
                          name="COOonBox"
                          id="COOonBox"
                          value={
                            this.state.data.COOonBox && this.state.data.COOonBox
                          }
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Country on Box</option>
                          {countries?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        {errors.COOonBox && (
                          <div className="alert alert-danger">
                            {errors.COOonBox}
                          </div>
                        )}
                      </div>
                      {!data._id && <LockValueCheckbox fieldName="lockCOOonBox" value={this.state.lockCOOonBox} onChange={this.handleBoolean} />}
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-4 col-form-label"
                        htmlFor="COOfromPackingList"
                      >COO from PackingList
                      </label>


                      <div className="col-lg-4">
                        <select
                          name="COOfromPackingList"
                          id="COOfromPackingList"
                          value={
                            this.state.data.COOfromPackingList && this.state.data.COOfromPackingList
                          }
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Country from Packing List</option>
                          {countries?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        {errors.COOfromPackingList && (
                          <div className="alert alert-danger">
                            {errors.COOfromPackingList}
                          </div>
                        )}
                      </div>
                      {!data._id && <LockValueCheckbox fieldName="lockCOOfromPackingList" value={this.state.lockCOOfromPackingList} onChange={this.handleBoolean} />}
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-4 col-form-label"
                        htmlFor="batch"
                      >Batch
                      </label>


                      <div className="col-lg-4">
                        <input type="text" name="batch" id="batch" placeholder="Enter batch" value={data.batch} onChange={this.handleChange} className="form-control" />

                        {errors.batch && (
                          <div className="alert alert-danger">
                            {errors.batch}
                          </div>
                        )}
                      </div>
                      {!data._id && <LockValueCheckbox fieldName="lockBatch" value={this.state.lockBatch} onChange={this.handleBoolean} />}
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-4 col-form-label"
                        htmlFor="note"
                      >Note
                      </label>

                      <div className="col-lg-4">
                        <textarea name="note" id="note" rows={5} className=" form-control " onChange={this.handleChange} value={
                          this.state.data.note &&
                          this.state.data.note
                        }  ></textarea>

                        {errors.note && (
                          <div className="alert alert-danger">
                            {errors.note}
                          </div>
                        )}
                      </div>
                      {!data._id && <LockValueCheckbox fieldName="lockNote" value={this.state.lockNote} onChange={this.handleBoolean} />}
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-4 col-form-label"
                        htmlFor="status"
                      >
                        Status
                      </label>


                      <div className="col-lg-4">
                        <select
                          name="status"
                          id="status"
                          value={
                            this.state.data.status && this.state.data.status
                          }
                          onChange={this.handleChange}
                          className="form-control"
                        >
                          <option value="">Select Status</option>
                          {this.statusOptions?.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                        {errors.status && (
                          <div className="alert alert-danger">
                            {errors.status}
                          </div>
                        )}
                      </div>
                      {!data._id && <LockValueCheckbox fieldName="lockStatus" value={this.state.lockStatus} onChange={this.handleBoolean} />}
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-lg-4 col-form-COOitem"
                        htmlFor="imageSrc"
                      >
                        Image
                      </label>


                      <div className="col-lg-4">
                        <input
                          type="file"
                          id="imageSrc"
                          name="imageSrc"
                          className="form-control-file m-b-5"
                          onChange={this.onChangeImgHandler}
                        />

                        {attachments?.length > 0 &&
                          attachments?.map((img, index) => (
                            <img
                              key={index}
                              src={`${apiUrl}/${img.filePath}`}
                              alt="Product"
                              className="img-thumbnail rounded-circle me-2 my-2"
                              style={{ width: "30px", height: "30px" }}
                            />
                          ))}

                        {errors.imageSrc && (
                          <div className="alert alert-danger">
                            {errors.imageSrc}
                          </div>
                        )}
                      </div>
                      {/* {!data._id && <LockValueCheckbox fieldName="lockAttachments" value={this.state.lockAttachments} onChange={this.handleBoolean} />} */}
                    </div>

                    <div class="form-group flex justify-content-start mt-4">
                      <button
                        type="submit"
                        disabled={this.validate() || this.state.loading}
                        class="btn btn-primary btn-sm"
                      >
                        Save
                      </button>
                      {!data._id && <button
                        type="button"
                        onClick={() => {
                          this.setState({ inputNewEntry: true });
                          this.doSubmit();
                        }}
                        disabled={this.validate() || this.state.loading}
                        class="btn btn-primary btn-sm"
                      >
                        Save and Input new entry
                      </button>}
                    </div>

                  </form>
                </PanelBody>
              </Panel>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(COOItem);

